import { BaseProvider } from 'src/app/core/services/base-provider';
import { HttpClient } from '@angular/common/http';
import { GlobalsService } from './globals.service';
import * as i0 from "@angular/core";
import * as i1 from "./globals.service";
import * as i2 from "@angular/common/http";
export class SettingService extends BaseProvider {
    constructor(globals, http) {
        super();
        this.globals = globals;
        this.http = http;
        this.baseUrl = "setting";
    }
    getLogoHeader() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + `/logo`;
            this.http
                .get(this.url)
                .subscribe((data) => {
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
}
SettingService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SettingService_Factory() { return new SettingService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient)); }, token: SettingService, providedIn: "root" });
